import { IFormService } from "../../service/form/FormService";

export default class GetFormDetailsInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formVersionId: number) {
    return this.formService.getFormDetails(formVersionId);
  }
}
